/**
* This file was auto-generated by the FrontendConstantsGenerator.
* Do not make direct changes to the file.
*/

export const ChargebeeInvoiceStatuses = {
  POSTED: 'posted',
  PENDING: 'pending',
  OPEN: 'payment_due',
  PAID: 'paid',
  UNCOLLECTIBLE: 'not_paid',
  VOID: 'voided',
}
